import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, Session, Period, ScenarioType } from '@/types/entities';

interface SessionState extends Session {
  setUser: (user: User) => void;
  setPeriod: (period: Period) => void;
  setScenario: (scenario: ScenarioType) => void;
  setTheme: (theme: 'light' | 'dark') => void;
  toggleTheme: () => void;
}

const defaultUser: User = {
  id: 'usr-001',
  name: 'Board Member',
  role: 'BRC_MEMBER',
  email: 'board@ukbank.plc',
  smfCode: 'SMF13',
};

const defaultPeriod: Period = {
  start_date: new Date(2024, 0, 1),
  end_date: new Date(2024, 11, 31),
  label: 'FY 2024',
};

export const useSessionStore = create<SessionState>()(
  persist(
    (set) => ({
      user: defaultUser,
      entity: 'UK_BANK_PLC',
      period: defaultPeriod,
      scenario: 'BASE',
      theme: 'light',

      setUser: (user) => set({ user }),
      setPeriod: (period) => set({ period }),
      setScenario: (scenario) => set({ scenario }),
      setTheme: (theme) => set({ theme }),
      toggleTheme: () =>
        set((state) => ({
          theme: state.theme === 'light' ? 'dark' : 'light',
        })),
    }),
    {
      name: 'riskmetrica-brc-session',
      partialize: (state) => ({
        user: state.user,
        period: state.period,
        scenario: state.scenario,
        theme: state.theme,
      }),
    }
  )
);
